// Benefits icons
import chat_bubble_icon from "@/assets/icons/fleet-inquiry/chat-bubble-left-right.svg";
import hand_raised_icon from "@/assets/icons/fleet-inquiry/hand-raised.svg";
import shield_check_icon from "@/assets/icons/fleet-inquiry/shield-check.svg";
import puzzle_icon from "@/assets/icons/fleet-inquiry/puzzle-piece.svg";

// Review card images
import cwd_review_imageUrl from "@/assets/images/fleetInquiry/cwd_review.png";
import clean_harbor_review_imageUrl from "@/assets/images/fleetInquiry/clean_harbor_review.png";

// Partner's icons
import abf_icon from "@/assets/icons/logos/abf.svg";
import clean_harbor_icon from "@/assets/icons/logos/clean_harbor.svg";
import cwd_icon from "@/assets/icons/logos/cwd.svg";
import dohrn_icon from "@/assets/icons/logos/dohrn.svg";
import ksi_icon from "@/assets/icons/logos/ksi.svg";

// Form icons
import cube_icon from "@/assets/icons/productDetails/cube.svg";
import eye_icon_url from "@/assets/icons/fleet-inquiry/eye.svg";

export const benefits = [
  {
    iconUrl: hand_raised_icon,
    title: "Hands-On Exploration",
  },
  {
    iconUrl: chat_bubble_icon,
    title: "Personalized Consultation",
  },
  {
    iconUrl: shield_check_icon,
    title: "In-Depth Reporting ",
  },
  {
    iconUrl: puzzle_icon,
    title: "Customized Solutions",
  },
];

export const reviewCards = [
  {
    imageUrl: clean_harbor_review_imageUrl,
    brandColor: "#FFEDF1",
    title: "CleanHarbors",
    review: `“Trackmate's GPS tracking solutions have become integral to our fleet management strategy”`,
  },
  {
    imageUrl: cwd_review_imageUrl,
    brandColor: "#BAE4FF",
    title: "CWD",
    review: `“CWD highly recommends Trackmate to businesses seeking a reliable GPS tracking solution.”`,
  },  
];

export const partners = [
  abf_icon,
  ksi_icon,
  cwd_icon,
  clean_harbor_icon,
  dohrn_icon,
];

export const formConfirmationData = [
  {
    iconUrl: eye_icon_url,
    title: "Today",
    description: "Our team will review your application within 24 hours",
  },
  {
    iconUrl: chat_bubble_icon,
    title: "In 2 days",
    description:
      "Then we'll notify you of your scheduled consultation within 48 hours.",
  },
  {
    iconUrl: cube_icon,
    title: "In 3-4 days",
    description:
      "Once we have confirmed the details together - we will send you 3 of our devices for a test drive.",
  },
];
